import { css } from 'lit';

var css_248z = css`:host{--toast-container-slot-elements-gap:0.5rem}slot{display:flex;flex-direction:column;gap:var(--toast-container-slot-elements-gap)}`;

export { css_248z as default };
//# sourceMappingURL=sgds-toast-container2.js.map
